import { render } from "./ManageSurveys.vue?vue&type=template&id=e28b00a8&scoped=true"
import script from "./ManageSurveys.vue?vue&type=script&lang=js"
export * from "./ManageSurveys.vue?vue&type=script&lang=js"

import "./ManageSurveys.vue?vue&type=style&index=0&id=e28b00a8&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28b00a8"]])

export default __exports__